import { FC } from "react";
import s from "./ServerStatus.module.scss";
import { getServerStatus } from "../../redux/reducers/app/appSelectors";
import { useAppSelector } from "../../redux/store";

export const ServerStatus: FC = () => {
  const serverStatus = useAppSelector(getServerStatus());

  return (
    <div className={`${s.wrapper} ${s[serverStatus]}`}>
      <div className={s.label}>Server</div>
      <div className={s.value}/>
    </div>
  );
};
